import { render, staticRenderFns } from "./UserListPopup.vue?vue&type=template&id=2b959a12&scoped=true&"
import script from "./UserListPopup.vue?vue&type=script&lang=js&"
export * from "./UserListPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b959a12",
  null
  
)

export default component.exports